(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('ProjectService', ProjectService);

    ProjectService.$inject = ['$http', 'API_URL'];

    function ProjectService ($http, API_URL) {
        var service = {
            validateProject: validate,
            loadProjectInfo: info,
            loadCountries: countries,
            loadSalutations: salutations,
            loadAcademicTitles: academicTitles,
            loadProjectLabels: loadProjectLabels,
            loadPendingLabels: loadPendingLabels,
            loadEscInactiveLabels: loadEscInactiveLabels
        };

        return service;

        function validate (name) {
            return $http.get(API_URL + 'project', {params:{name:name}});
        }

        function countries(project) {
            return $http.get(API_URL + 'country', {params:{project:project}});
        }

        function salutations(project) {
            return $http.get(API_URL + 'salutation', {params:{project:project}});
        }

        function academicTitles(project) {
            return $http.get(API_URL + 'academictitle', {params:{project:project}});
        }

        function info(project) {
            return $http.get(API_URL + 'project/info', {params:{project:project}});
        }

        function loadProjectLabels(key) {
            return $http.get(API_URL + 'project/translations', {params:{key:key}});
        }

        function loadPendingLabels(){
            return $http.get(API_URL + 'project/pending');
        }

        function loadEscInactiveLabels(){
            return $http.get(API_URL + 'project/escinactive');
        }
    }
})();
